export const de = {
  search: {
    placeholder: "Geben Sie ein Wort ein, nach dem gesucht werden soll...",
    results: "Suchergebnisse anzeigen",
    search: "Suche",
  },
};
